import SpeedIcon from '@material-ui/icons/Speed';
import UnitList from './UnitList';

const Units = {
  list: UnitList,
  icon: SpeedIcon
};
export default Units;
